export default function WatchCoursesLoader() {
    const dummyArray = Array.from({ length: 3 }, (_, i) => i);
    return (
        <div className="seriesMain1 rounded-[7px] grid max-[1200px]:grid-cols-1 grid-cols-2 seriesCoursesLoaderMain">

            {dummyArray.map((item, index) => (
                <div key={index}>
                    <div className="grid grid-cols-[125px_1fr] seriesCardMain rounded-[7px] seriesCoursesLoaderMain_2">
                        {/* Image Placeholder */}
                        <div className="w-[125px] h-[125px] watchSeriesLoaderMain_com2 rounded-lg"></div>
                        <div className="flex flex-col justify-center pl-[10px] pr-[30px]">
                            <div className="w-full">
                                {/* Title Placeholder */}
                                <div className="h-3 watchSeriesLoaderMain_com2 rounded"></div>

                                {/* Text Placeholder */}
                                <div className="h-3 mt-[10px] watchSeriesLoaderMain_com2 rounded"></div>

                                {/* Progress bar Placeholder */}
                                <div className="h-5 mt-[10px] watchSeriesLoaderMain_com2 rounded"></div>

                            </div>
                        </div>
                    </div>

                </div>
            ))}
        </div>
    );
}
